module.exports = __webpack_public_path__ + "static/img/IMG_20160930_173551.e19cf033.jpg";